module.exports = __webpack_public_path__ + "img/mockup-1.ea00b72b.png";